<template>
  <component
    :is="component"
    :filterQuestion="question"
  />
</template>

<script>
import FilterBool from '@/components/inputs/FilterBool'
import FilterMultiSelect from '@/components/inputs/FilterMultiselect'

export default {
  name: 'FilterQuestion',

  props: {
    question: {
      type: Object,
      default: void 0,
      required: true
    }
  },
  computed: {
    component () {
      switch (this.question.type.type) {
        case 'bool':
          return FilterBool
        case 'multiselect':
          return FilterMultiSelect
        default:
          throw new Error('invalid question type')
      }
    },

    dense () {
      return this.question.type.type === 'select' || this.question.type.type === 'select_with_freetext' || this.question.type.type === 'multiselect'
    }
  }
}
</script>

<style scoped>
.questionWrap{
  width: 100%;
}
</style>
